<template>
	<div class="content">
		<div>今日已经锻炼{{ totalNum }}分钟</div>
		<div class="record-auto">
			<div class="record-auto-operation">
				计时器: <span class="record-auto-num">{{ computeTime ? computeTime : '' }}</span>
				<van-button plain type="primary" @click="startClock" size="small">{{ keepTime }}</van-button>
			</div>
		</div>
		<div class="record-manual">
			<div class="custom_time">手动记录: <van-field type="digit" @input="inputDuration" v-model="duration" label=""
					placeholder="输入运动时长" /></div>
			<van-button plain type="primary" @click="recordSport" size="small">记录运动时长</van-button>
		</div>
		<div class="data-list" v-if="dataList.length > 0">
			<div class="data-list-item data-list-header">
				<span class="data-list_interval">时长(分钟)</span>
				<span class="data-list_time">时间</span>
				<span class="data-list_operate">操作</span>
			</div>
			<div class="data-list-content">
				<div class="data-list-item" v-for="item in dataList" :key="item.id">
					<span class="data-list_interval">{{ item.duration.toFixed(2) }}</span>
					<span class="data-list_time">
						{{ item.time }}
					</span>
					<span class="data-list_operate">
						<van-button type="danger" size="small" @click="deleteSleepRecord(item.id)">删除</van-button>
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	getSportList,
	addSportRecord,
	getTotalSportListByDate,
	deleteSPortRecord
} from '../util/api'
import { Dialog } from 'vant';
export default {
	name: 'SportCom',
	data() {
		return {
			inputDuration: null,
			duration: null,
			dataList: [],
			isStart: false,
			intervalTimeId: null,
			computeStartTime: null,
			computeTime: null,
			totalNum: 0
		}
	},
	methods: {
		refreshPage: () => {
			location.reload()
		},
		getSportList: function () {
			getSportList({
				startDate: this.getPastMonthDate(6),
				endDate: this.getPastMonthDate(0)
			}).then((res) => {
				this.dataList = res.data || []
				this.getTodayData()
			})
		},
		getTodayData: function () {
			const date = new Date()
			const todayDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
			getTotalSportListByDate({ startDate: todayDate, endDate: todayDate }).then((res) => {
				let totalNum = 0
				if (res?.data?.length > 0) {
					totalNum = res.data[0].total
				}
				this.$set(this, 'totalNum', totalNum.toFixed(2));
			})
		},
		recordSport: function () {
			this.addRecord(this.duration)
		},
		addRecord: function (duration) {
			addSportRecord({
				duration: duration || 0,
				time: new Date().toLocaleString()
			}).then(() => {
				this.$set(this, 'duration', null);
				this.getSportList();
			})
		},
		getPastMonthDate(daysAgo) {
			const today = new Date();
			const needDaysAgo = new Date(today.setDate(today.getDate() - daysAgo));
			const year = needDaysAgo.getFullYear();
			const month = needDaysAgo.getMonth() + 1; // 月份是从0开始的，所以加1
			const date = needDaysAgo.getDate();
			return `${year}-${month}-${date}`;
		},
		startClock() {
			if (this.isStart) {
				const timeArray = this.computeTime.split(":")
				const duration = parseInt(timeArray[0]) + parseInt(timeArray[1]) / 60
				this.addRecord(duration)
				clearInterval(this.intervalTimeId)
				this.$set(this, 'computeTime', null);
			} else {
				this.computeStartTime = new Date().getTime()
				this.$set(this, 'computeTime', "0:00");
				this.intervalTimeId = setInterval(this.updateCountdown, 1000)
			}
			this.$set(this, 'isStart', !this.isStart);
		},
		updateCountdown() {
			const currentTime = new Date().getTime();
			const timeLeft = currentTime - this.computeStartTime;
			const minutes = Math.floor((timeLeft / 1000 / 60) % 60);
			const seconds = Math.floor((timeLeft / 1000) % 60);
			this.$set(this, 'computeTime', minutes + ":" + (seconds < 10 ? '0' : '') + seconds);
		},
		deleteSleepRecord: function (id) {
			Dialog.confirm({
				message: '确认删除这次记录吗'
			}).then(() => {
				deleteSPortRecord({
					id: id
				}).then(() => {
					this.getSportList()
				})
			})

		},
	},
	mounted() {
		this.getSportList();
		if (this.intervalId) {
			clearInterval(this.intervalId)
		}
		this.intervalId = setInterval(() => {
			this.getSportList()
		}, 20000);
	},
	computed: {
		keepTime() {
			return this.isStart ? " 计时结束" : "计时开始"
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.add-menu .van-cell::after {
	display: none !important;
}
</style>
<style scoped>
.content {
	/* Q版：柔和底色 + 卡片 */
	--q-bg0: #fff7fb;
	--q-bg1: #f2fbff;
	--q-card: rgba(255, 255, 255, 0.92);
	--q-line: rgba(15, 23, 42, 0.08);
	--q-shadow: 0 10px 24px rgba(17, 24, 39, 0.08);
	--q-shadow-sm: 0 6px 14px rgba(17, 24, 39, 0.08);
	--q-radius: 18px;
	--q-primary: #34c3ff;
	--q-primary-2: #6ee7ff;
	--q-danger: #ff5f7a;

	padding: 14px 14px 18px;
	display: flex;
	flex-direction: column;
	height: 100%;
	box-sizing: border-box;
	font-size: 14px;
	position: relative;
	font-family: "Comic Sans MS", "Microsoft YaHei UI", "PingFang SC", "Hiragino Sans GB", system-ui, -apple-system,
		BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
	background: radial-gradient(120% 90% at 20% 0%, var(--q-bg0) 0%, transparent 60%),
		radial-gradient(120% 90% at 90% 30%, var(--q-bg1) 0%, transparent 55%),
		#ffffff;
}

.content::before,
.content::after {
	content: "";
	position: fixed;
	z-index: -1;
	pointer-events: none;
	opacity: 0.9;
}
.content::before {
	width: 240px;
	height: 240px;
	left: -90px;
	top: 140px;
	background: radial-gradient(circle at 30% 30%, rgba(255, 184, 220, 0.55), transparent 60%),
		radial-gradient(circle at 70% 70%, rgba(110, 231, 255, 0.45), transparent 62%);
	border-radius: 999px;
}
.content::after {
	width: 280px;
	height: 280px;
	right: -140px;
	bottom: 90px;
	background: radial-gradient(circle at 40% 30%, rgba(196, 255, 214, 0.5), transparent 60%),
		radial-gradient(circle at 70% 70%, rgba(255, 224, 170, 0.45), transparent 62%);
	border-radius: 999px;
}
/* 不要对 `.content > *` 统一加 position/z-index，会破坏 Vant Dialog/Popup 的 fixed 布局 */

.content /deep/ .van-button {
	border-radius: 999px;
	transition: transform 120ms ease, filter 120ms ease;
}
.content /deep/ .van-button:active {
	transform: translateY(1px) scale(0.985);
	filter: saturate(1.05);
}
.content /deep/ .van-button--plain.van-button--primary {
	border: 1px solid rgba(52, 195, 255, 0.55);
	background: rgba(255, 255, 255, 0.86);
	color: #0ea5e9;
	box-shadow: 0 6px 14px rgba(52, 195, 255, 0.12);
}
.content /deep/ .van-button--danger {
	border: none;
	background: linear-gradient(180deg, #ff6b84 0%, var(--q-danger) 100%);
	box-shadow: 0 8px 18px rgba(255, 95, 122, 0.22);
}

.record-auto,
.record-manual {
	border: 1px solid var(--q-line);
	border-radius: var(--q-radius);
	background: var(--q-card);
	box-shadow: var(--q-shadow-sm);
	padding: 10px 12px;
	margin-top: 10px;
}

.record-auto-num {
	display: flex;
	justify-content: center;
	font-size: 36px;
	font-weight: bold;
	color: red;
}

.record-auto-operation {
	display: flex;
	align-items: center;
	gap: 6px;
}

.today-num {
	display: flex;
	justify-content: space-between;
}

.record-manual {
	display: flex;
	align-items: center;
	gap: 8px;
}

.custom_time {
	display: flex;
	align-items: center;
}

.custom_time /deep/ .van-field {
	width: 90px;
	padding: 0;
	margin: 6px;
}

.data-list-header {
	margin-bottom: 12px;
}

.data-list {
	flex: 1;
	display: flex;
	flex-direction: column;
	overflow: auto;
	margin-top: 12px;
	margin-bottom: 6px;
	border: 1px solid var(--q-line);
	border-radius: var(--q-radius);
	background: rgba(255, 255, 255, 0.86);
	box-shadow: var(--q-shadow-sm);
	padding: 10px 10px 6px;
	box-sizing: border-box;
}

.data-list-item {
	display: flex;
	align-items: center;
	margin-bottom: 8px;
}

.data-list_time {
	display: flex;
	flex-direction: column;
	flex: 1;
}

.data-list_operate {
	width: 50px;
}

.data-list_num {
	width: 72px;
}

.data-list_interval {
	width: 86px;
}

.data-list-content {
	height: 360px;
	overflow-y: auto;
	flex: 1;
	font-size: 14px;
}

.last-eat {
	display: flex;
	flex-direction: column;
	gap: 2px;
}

.bule-font {
	color: #1989fa;
}

.red-font {
	color: #ee0a24;
}

.bold-font {
	font-weight: bold;
}

.red-font {
	color: #ee0a24;
}
</style>
